var featureProps = {
  animation: ["animate", "variants", "whileHover", "whileTap", "exit", "whileInView", "whileFocus", "whileDrag"],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
var featureDefinitions = {};
var _loop = function _loop(key) {
  featureDefinitions[key] = {
    isEnabled: function isEnabled(props) {
      return featureProps[key].some(function (name) {
        return !!props[name];
      });
    }
  };
};
for (var key in featureProps) {
  _loop(key);
}
export { featureDefinitions };